var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkingSolutions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Networking_Solutions",
    "data-name": "Networking Solutions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 88,
    cy: 88,
    r: 88,
    fill: "rgba(214,233,255,0.7)",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell_tower_black_24dp",
    transform: "translate(53 53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11386",
    "data-name": "Group 11386",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11386-2",
    "data-name": "Group 11386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M80.656,110.151l8.783-24.8,8.679,24.8Z",
    transform: "translate(-55.164 -57.435)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M12.09,37.215l4.074-4.074a17.053,17.053,0,0,1-5.093-11.883A15.926,15.926,0,0,1,16.165,9.374L12.09,5.3A22.679,22.679,0,0,0,5.3,21.257,22.679,22.679,0,0,0,12.09,37.215Z",
    transform: "translate(5.904 2.848)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M21.974,2.9,17.9,6.974a28.542,28.542,0,0,1,8.148,20.032A28.542,28.542,0,0,1,17.9,47.037l4.074,4.074A33.341,33.341,0,0,0,31.82,27.006,34.778,34.778,0,0,0,21.974,2.9Z",
    transform: "translate(36.083 -2.9)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M15.92,6.974,11.846,2.9A34.778,34.778,0,0,0,2,27.006a34.778,34.778,0,0,0,9.846,24.106l4.074-4.074a28.7,28.7,0,0,1,0-40.063Z",
    transform: "translate(-2 -2.9)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M19.574,37.215a22.679,22.679,0,0,0,6.79-15.957A24.217,24.217,0,0,0,19.574,5.3L15.5,9.374a17.053,17.053,0,0,1,5.093,11.883A15.926,15.926,0,0,1,15.5,33.141Z",
    transform: "translate(30.335 2.848)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M32.464,15.988a8.488,8.488,0,1,0-16.976,0,8.385,8.385,0,0,0,2.954,6.383L7,56.73h6.79l2.275-6.79H31.921l2.241,6.79h6.79L29.51,22.371A8.385,8.385,0,0,0,32.464,15.988ZM18.306,43.149l5.67-16.976,5.67,16.976Z",
    transform: "translate(9.976 8.118)",
    fill: "#12355f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingSolutions);
export default __webpack_public_path__ + "static/media/Networking Solutions.cc2c1ed9c069b119682631999e0b51d3.svg";
export { ForwardRef as ReactComponent };